import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Instagram, Bike, CalendarDays, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import ShareMenu from "@/components/ShareMenu";
import { formatDate } from "@/components/EventCard";

export default function MemberProfile() {
  const { ref } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/members/${ref}`).then((r) => setData(r.data)).catch(() => {}); }, [ref]);

  if (!data) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-[#e0481f]" /></div>;
  const m = data.member;
  const origin = window.location.origin;

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12">
      <div className="card-warm rounded-3xl overflow-hidden">
        <div className="h-32 sm:h-40 bg-gradient-to-r from-[#2a1d15] via-[#3a2416] to-[#1a1816] relative grain" />
        <div className="px-6 sm:px-10 pb-8 -mt-16">
          <div className="w-32 h-32 rounded-2xl overflow-hidden gold-border bg-[#221f1c] mb-4">
            {m.photo ? <img src={m.photo} alt={m.nickname} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center"><Logo className="h-16 opacity-50" /></div>}
          </div>
          <h1 className="headline text-4xl text-[#f7f3ec]">{m.nickname}</h1>
          <div className="flex flex-wrap gap-4 mt-2 text-sm text-[#a9a196]">
            <span className="flex items-center gap-1.5"><Bike size={15} className="text-[#e0481f]" /> {m.rides || "Rider"}</span>
            <span className="flex items-center gap-1.5"><CalendarDays size={15} className="text-[#e0481f]" /> Member since {formatDate(m.created_at)}</span>
          </div>
          {m.bio && <p className="text-[#d6cec2] mt-4 leading-relaxed max-w-2xl">{m.bio}</p>}
          {m.socials?.instagram && (
            <a href={m.socials.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-4 text-[#f3c649] text-sm"><Instagram size={16} /> Instagram</a>
          )}
        </div>
      </div>

      <div className="card-warm rounded-2xl p-6 mt-6">
        <h2 className="headline text-2xl text-[#f7f3ec] mb-1">Ride With {m.nickname}</h2>
        <p className="text-[#a9a196] text-sm mb-4">Buy tickets through this link and your purchase is credited to {m.nickname}'s account.</p>
        <ShareMenu url={`${origin}/events?ref=${m.ref_code}`} label={`${m.nickname}'s ticket link`} />
      </div>

      {data.upcoming_events?.length > 0 && (
        <div className="mt-6">
          <h2 className="headline text-2xl text-[#f7f3ec] mb-4">Upcoming Events</h2>
          <div className="space-y-3">
            {data.upcoming_events.map((e) => (
              <a key={e.id} href={`/events/${e.slug}?ref=${m.ref_code}`} className="card-warm rounded-xl p-4 flex items-center gap-4 hover:border-[#e0481f]/40 transition-colors">
                <img src={e.banner_image} alt={e.title} className="w-16 h-16 rounded-lg object-cover" />
                <div>
                  <h3 className="headline text-lg text-[#f7f3ec]">{e.title}</h3>
                  <p className="text-[#a9a196] text-sm">{formatDate(e.date)} • {e.location}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
